/* eslint-disable import/no-cycle */
import React from 'react';
import PropTypes from 'prop-types';
import { Anchor, ColorSwatch } from '@mantine/core';
import { AlertCircle } from 'tabler-icons-react';
import AppFlexbox from '../../../../common/AppFlexbox';
import AppText from '../../../../common/AppText';

const WsCheckoutCartProductCardAlert = ({
  isOrderHistory,
  submitting,
  onRemoveUnavailableProducts,
  onCustomizeProduct,
  isUnavailable,
  hasChanges,
  requiresProductUpdate,
  requiresPrintImagesUpdate,
  isBundleProduct,
  quantityLeft,
  outOfStock,
  tooManyInCart
}) =>
  !isOrderHistory &&
  (requiresProductUpdate ||
  requiresPrintImagesUpdate ||
  isUnavailable ||
  hasChanges ? (
    <AppFlexbox
      style={{
        padding: 10,
        backgroundColor: isUnavailable ? '#c40000' : '#eca70a',
        color: '#FFF',
        alignItems: 'center',
        gap: 8
      }}
    >
      <AlertCircle size={18} />{' '}
      {requiresProductUpdate ? (
        <AppText style={{ fontSize: 14 }}>
          This {isBundleProduct ? 'bundle' : 'product'} has changes that require
          your attention
        </AppText>
      ) : requiresPrintImagesUpdate ? (
        <AppText style={{ fontSize: 14 }}>
          This {isBundleProduct ? 'bundle' : 'product'} has print designs that
          require refreshing.
        </AppText>
      ) : isUnavailable ? (
        <AppText style={{ fontSize: 14 }}>
          This {isBundleProduct ? 'bundle' : 'product'} is no longer available
        </AppText>
      ) : (
        <AppText style={{ fontSize: 14 }}>
          This {isBundleProduct ? 'bundle' : 'product'} has been changed
        </AppText>
      )}
      {!submitting &&
        (requiresProductUpdate ? (
          <Anchor
            onClick={onCustomizeProduct}
            style={{ marginLeft: 'auto', color: '#FFF', fontSize: 14 }}
            underline="always"
          >
            Customize
          </Anchor>
        ) : (
          <Anchor
            onClick={onRemoveUnavailableProducts}
            style={{ marginLeft: 'auto', color: '#FFF', fontSize: 14 }}
            underline="always"
          >
            Update cart
          </Anchor>
        ))}
    </AppFlexbox>
  ) : (
    quantityLeft != null &&
    (outOfStock ? (
      <AppFlexbox
        style={{
          padding: 10,
          alignItems: 'center',
          borderBottom: '1px solid #dee2e6',
          gap: 8
        }}
      >
        <ColorSwatch color="#c40000" size={16} />
        <AppText style={{ fontSize: 14 }}>Out of stock</AppText>
        {!submitting && (
          <Anchor
            onClick={onRemoveUnavailableProducts}
            style={{ marginLeft: 'auto', fontSize: 14 }}
            underline="always"
          >
            Update cart
          </Anchor>
        )}
      </AppFlexbox>
    ) : tooManyInCart ? (
      <AppFlexbox
        style={{
          padding: 10,
          alignItems: 'center',
          borderBottom: '1px solid #dee2e6',
          gap: 8
        }}
      >
        <ColorSwatch color="#c40000" size={18} />
        <AppText style={{ fontSize: 14 }}>
          Only {quantityLeft} left. Please remove some from your cart.
        </AppText>
        {!submitting && (
          <Anchor
            onClick={onRemoveUnavailableProducts}
            style={{ marginLeft: 'auto', fontSize: 14 }}
            underline="always"
          >
            Update cart
          </Anchor>
        )}
      </AppFlexbox>
    ) : quantityLeft <= 25 ? (
      <AppFlexbox
        style={{
          padding: 10,
          alignItems: 'center',
          borderBottom: '1px solid #dee2e6',
          gap: 8
        }}
      >
        <ColorSwatch color="#eca70a" size={18} />
        <AppText style={{ fontSize: 14 }}>
          Low stock: {quantityLeft} left
        </AppText>
      </AppFlexbox>
    ) : null)
  ));

WsCheckoutCartProductCardAlert.propTypes = {
  hasChanges: PropTypes.bool,
  isBundleProduct: PropTypes.bool,
  isOrderHistory: PropTypes.bool,
  isUnavailable: PropTypes.bool,
  onCustomizeProduct: PropTypes.func,
  onRemoveUnavailableProducts: PropTypes.func,
  outOfStock: PropTypes.bool,
  quantityLeft: PropTypes.number,
  requiresPrintImagesUpdate: PropTypes.bool,
  requiresProductUpdate: PropTypes.bool,
  submitting: PropTypes.bool,
  tooManyInCart: PropTypes.bool
};

export default WsCheckoutCartProductCardAlert;
